import React, { useState } from "react";
import date from "date-and-time";
import { Calendar } from "react-calendar";

import Popup from "components/Popover/BasicPopup";
import { daysOfWeek, months } from "./constants";

const baseCard =
  "flex h-full shadow-sm rounded-md cursor-pointer justify-center w-24 items-center -space-y-2 active:scale-95 active:shadow-xl bg-sky-950 text-white";
const styleMonth = "text-xs font-semibold uppercase text-yellow-300";
const styleDay = "text-xs text-white";

function DateCard({ dateSelected, onChangeDate }) {
  const [selected, setSelected] = useState(new Date());

  function onChange(_date) {
    onChangeDate(_date);
    setSelected(_date);
  }

  const button = (
    <div data={selected.toDateString()} className={baseCard}>
      <span className="text-[28px] font-semibold">{selected.getDate()}</span>
      <div className="grid pl-2">
        <span className={styleMonth}>{months[selected.getMonth()]}</span>
        <span className={styleDay}>{daysOfWeek[selected.getDay()]}</span>
      </div>
    </div>
  );
  return (
    <Popup button={button}>
      <Calendar value={selected} onChange={onChange} />
    </Popup>
  );
}

export default DateCard;
